(function () {
  var MQ = '(max-width: 989px)';

  function refreshGrid(grid) {
    if (!grid || typeof Swiper === 'undefined') return;

    var swiperEl = grid.querySelector('.article-grid__swiper');
    var scrollbarEl = grid.querySelector('.article-grid__scrollbar');
    var scrollbarWrap = grid.querySelector('.article-grid__scrollbar-wrap');
    if (!swiperEl || !scrollbarEl) return;

    var mq = window.matchMedia(MQ);
    var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

    function hideBar() {
      if (scrollbarWrap) scrollbarWrap.hidden = true;
    }

    function showBar() {
      if (scrollbarWrap) scrollbarWrap.hidden = false;
    }

    if (!mq.matches || slideCount <= 1) {
      if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
      hideBar();
      return;
    }

    showBar();

    if (swiperEl.swiper) {
      swiperEl.swiper.update();
      return;
    }

    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 600,
      watchOverflow: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var grids = root.querySelectorAll ? root.querySelectorAll('[data-cs-article-grid]') : [];
    grids.forEach(refreshGrid);
  }

  function onMqChange() {
    initAll(document);
  }

  if (!window.csMainBlogArticleSlidersBound) {
    window.csMainBlogArticleSlidersBound = true;
    window.matchMedia(MQ).addEventListener('change', onMqChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    var grids = target.querySelectorAll('[data-cs-article-grid]');
    if (!grids.length) return;
    grids.forEach(refreshGrid);
  });
})();
